// extracted by mini-css-extract-plugin
export default {"collapsible":"Collapsible_collapsible__yLB2h","collapsed":"Collapsible_collapsed__vUShy"};